import { IIndexable } from "types/common";
import {
  AiOutlineInfoCircle,
  AiOutlineCheckCircle,
  AiOutlineCloseCircle,
  AiOutlineWarning,
} from "react-icons/ai";

export const alertTypeIconMapping: IIndexable = {
  info: AiOutlineInfoCircle,
  success: AiOutlineCheckCircle,
  danger: AiOutlineCloseCircle,
  warning: AiOutlineWarning,
};

export const alertTypeColorMapping: IIndexable = {
  info: {
    bg: "#F7F1FF",
    color: "#A570FF",
  },
  success: {
    bg: "#F1FFF7",
    color: "#206846",
  },
  danger: {
    bg: "#FFF1F4",
    color: "#FF002E",
  },
  warning: {
    bg: "#F1FFF7",
    color: "#206846",
  },
};
